export default "/4cc6ed3e985ef0bef0747dc70ddc0cc2.svg";